import * as React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { tokens } from '../../Components/DashboardTheme/DashboardTheme';
import { Kicker } from '../../Components/Typography/Typography';
import Reveal from '../../Components/Reveal/Reveal';
import Video from '../../video/maestro-pao-cleme.mp4';
import BackgroundImage from '../../img/mario-cleme-corner.webp';
import PosterImage from '../../img/next-gala-img.webp';

export default function NextGala() {
  const theme = useTheme();
  const isScreenSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        overflow: 'hidden',
        backgroundColor: tokens.ink,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2.5, md: 6 },
        pt: { xs: 12, md: 16 },
        pb: { xs: 6, md: 10 },
      }}
    >
      {/* ---------- Blurred backdrop ---------- */}
      {isScreenSmall ? (
        <Box
          component="img"
          src={BackgroundImage}
          alt=""
          aria-hidden
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(14px) brightness(0.32) grayscale(30%)',
            transform: 'scale(1.1)',
          }}
        />
      ) : (
        <Box
          component="video"
          autoPlay
          loop
          muted
          playsInline
          poster={BackgroundImage}
          src={Video}
          aria-hidden
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(16px) brightness(0.32) grayscale(30%)',
            transform: 'scale(1.1)',
          }}
        />
      )}

      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          background: `radial-gradient(60% 60% at 50% 40%, ${tokens.red}1F 0%, transparent 70%)`,
        }}
      />

      {/* ---------- Poster ---------- */}
      <Box sx={{ position: 'relative', textAlign: 'center', width: '100%' }}>
        <Reveal>
          <Kicker>Prossimo evento</Kicker>
          <Box
            component="h1"
            sx={{
              m: 0,
              mt: 2,
              mb: { xs: 4, md: 5 },
              fontFamily: tokens.display,
              fontSize: { xs: 46, sm: 68, md: 92 },
              lineHeight: 0.95,
              color: tokens.white,
            }}
          >
            PROSSIMO GALÀ
          </Box>
        </Reveal>

        <Reveal delay={120}>
          <Box
            sx={{
              position: 'relative',
              display: 'inline-block',
              maxWidth: '100%',
              ':hover img': { transform: 'scale(1.02)' },
            }}
          >
            <Box
              aria-hidden
              sx={{
                position: 'absolute',
                inset: 0,
                transform: 'translate(16px, 16px)',
                border: `1px solid ${tokens.red}`,
                pointerEvents: 'none',
              }}
            />
            <Box
              component="img"
              src={PosterImage}
              alt="Locandina del prossimo galà"
              sx={{
                position: 'relative',
                display: 'block',
                maxWidth: '100%',
                maxHeight: { xs: 'none', md: '68vh' },
                width: 'auto',
                objectFit: 'contain',
                border: `1px solid ${tokens.lineStrong}`,
                boxShadow: '0 30px 80px rgba(0,0,0,0.6)',
                transition: `transform 0.8s ${tokens.ease}`,
              }}
            />
          </Box>
        </Reveal>
      </Box>
    </Box>
  );
}
